import { render } from "./Map.vue?vue&type=template&id=4a74853f&ts=true"
import script from "./Map.vue?vue&type=script&lang=ts"
export * from "./Map.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__